/**
 * Opens an existing on-page form inside a modal dialog.
 *
 * Shopify Forms has no public API for opening a form by id, so the form is
 * embedded on the page as an app block and relocated into the dialog the first
 * time the trigger is clicked. Relocating rather than cloning keeps the app's
 * own event listeners and submit handling intact.
 */
class FormPopup extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('[data-form-popup-dialog]');
    this.slot = this.querySelector('[data-form-popup-content]');
    this.trigger = this.querySelector('[data-form-popup-trigger]');

    if (!this.dialog || !this.trigger) return;

    this.trigger.addEventListener('click', this.open);
    this.dialog.addEventListener('click', this.handleBackdropClick);

    this.querySelectorAll('[data-form-popup-close]').forEach((button) => {
      button.addEventListener('click', this.close);
    });

    // Shopify redirects back to the page after a contact form submit, so the
    // dialog is reopened to show the confirmation the merchant expects.
    if (this.hasAttribute('data-open-on-load') || this.querySelector('[data-form-popup-open]')) {
      this.open();
    }
  }

  open = () => {
    this.adoptForm();
    this.dialog.showModal();
  };

  close = () => {
    this.dialog.close();
  };

  /** Closes when the backdrop, rather than the dialog content, is clicked. */
  handleBackdropClick = (event) => {
    if (event.target === this.dialog) this.close();
  };

  adoptForm() {
    if (this.adopted || !this.slot) return;

    const selector = this.dataset.target;
    if (!selector) return;

    const form = document.querySelector(selector);
    if (!form) {
      console.warn(`[form-popup] No element matches "${selector}"`);
      return;
    }

    this.slot.appendChild(form);
    form.hidden = false;
    this.adopted = true;
  }
}

if (!customElements.get('form-popup')) {
  customElements.define('form-popup', FormPopup);
}
